import React, { forwardRef } from 'react';
import { ResizerProps } from './iLayout';
import classNames from 'classnames';
import { WebUI } from "../../wui-core/src/index";

const Resizer = forwardRef<HTMLDivElement, ResizerProps>((props, ref) => {
    const {
        className,
        onClick,
        onDoubleClick,
        onMouseDown,
        onTouchEnd,
        onTouchStart,
        clsPrefix,
        direction,
        style = {},
        trigger,
        fixeNail,
        resizerable,
        primary,
        resizerClassName,
        collapsed,
        fieldid
    } = props;
    const classes = classNames(clsPrefix, direction, className, resizerClassName);
    const classesLine = classNames(clsPrefix, {
        [`${clsPrefix}-line-not-allowed`]: !resizerable,
        [`${clsPrefix}-line-collapsed`]: !!collapsed
    },
    `${clsPrefix}-line`,
    `${clsPrefix}-line-${primary}`
    );

    return (
        <div className={classes} ref={ref}>
            <span
                className={classesLine}
                style={style}
                onMouseDown={onMouseDown}
                onTouchStart={event => {
                    event.preventDefault();
                    onTouchStart && onTouchStart(event);
                }}
                onTouchEnd={event => {
                    event.preventDefault();
                    onTouchEnd && onTouchEnd(event);
                }}
                onClick={event => {
                    if (onClick) {
                        event.preventDefault();
                        onClick(event);
                    }
                }}
                onDoubleClick={event => {
                    if (onDoubleClick) {
                        event.preventDefault();
                        onDoubleClick(event);
                    }
                }}
                fieldid={fieldid}
            />
            {trigger && React.cloneElement(trigger)}
            {fixeNail && React.cloneElement(fixeNail)}
        </div>
    );
});

Resizer.displayName = 'Resizer';

export default WebUI({name: "spliter-resizer"})(Resizer);